export const GetBankAccountList = ({ bankId, stateId, pageNumber, pageSize }) =>
  `/BankAccount/GetBankAccountList?BankId=${bankId || 0}&StateId=${
    stateId || 0
  }&PageNumber=${pageNumber || -1}&PageSize=${pageSize || -1}`;

export const GetBankAccountForm = "/BankAccount/GetBankAccountForm";

export const BankAccountEdit = "/BankAccount/BankAccountEdit";

export const BankAccountDelete = "/BankAccount/BankAccountDelete";

export const GetBankAccountEdit = (id) =>
  `/BankAccount/GetBankAccountEdit?Id=${id}`;
